import React from "react"

const hubspotScriptUrl = "https://js.hsforms.net/forms/v2.js"

export const useHubspotForm = ({ locale, ...rest }) => {
  React.useEffect(() => {
    const formId = rest.formId

    const formSubmissionListener = event => {
      if (
        event.data.type === "hsFormCallback" &&
        event.data.eventName === "onFormSubmitted" &&
        event.data.id === formId
      ) {
        if (rest.onSubmitted) {
          rest.onSubmitted(event)
        }
      }
    }

    const tryInitHubspotForm = (retryCount = 0) => {
      if (window.hbspt && window.hbspt.forms && window.hbspt.forms.create) {
        window.hbspt.forms.create({
          ...rest,
          locale,
        })
      } else if (retryCount < 3) {
        setTimeout(() => tryInitHubspotForm(retryCount + 1), 500)
      }
    }

    const loadHubspotScript = () => {
      const existingScript = document.querySelector(
        `script[src="${hubspotScriptUrl}"]`
      )
      if (!existingScript) {
        const script = document.createElement("script")
        script.src = hubspotScriptUrl
        document.body.appendChild(script)
        script.onload = () => tryInitHubspotForm()
      } else {
        tryInitHubspotForm()
      }
    }

    loadHubspotScript()
    window.addEventListener("message", formSubmissionListener)

    return () => {
      window.removeEventListener("message", formSubmissionListener)
    }
  }, [locale, rest.formId])
}
